import { ExcelExportParameters } from '@scts/models';

export const decisionsExcelExportParams: ExcelExportParameters = {
    tableHeaders: [
        "Case Reference",
        "Decision",	
        "Appellant",	
        "Respondent",	
        "Date",	
        "Appeal Type",
        "Appeal Reason",
        "Address",
        "Representative",
        "Valuation Roll Reference",
    ],
    typeOfData: "decisions",
    tableColumnsWidth: [22, 30, 18, 46, 18, 36, 46, 36, 34, 26],
};